/**
 * ReviewsContent - Reviews Tab
 * 
 * Placeholder for reviews functionality
 */

import React from 'react';
import { Star, MessageSquare } from 'lucide-react';

interface ReviewsContentProps {
  onWriteReview: () => void;
}

export const ReviewsContent: React.FC<ReviewsContentProps> = ({
  onWriteReview,
}) => {
  return (
    <div className="px-4 py-8">
      <div className="text-center max-w-sm mx-auto">
        {/* Icon */}
        <div 
          className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4"
          style={{ background: 'rgba(14,127,79,0.08)' }}
        >
          <MessageSquare className="h-7 w-7 text-emerald-700" strokeWidth={1.5} />
        </div>
        
        {/* Text */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Noch keine Bewertungen
        </h3>
        <p className="text-gray-500 text-sm mb-6">
          Sei der Erste, der dieses Restaurant bewertet und anderen Gästen hilft.
        </p>
        
        {/* CTA */}
        <button
          onClick={onWriteReview}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl transition-colors active:scale-[0.98]"
          style={{
            background: 'linear-gradient(135deg, #0E7F4F 0%, #18B66A 100%)',
            boxShadow: '0 4px 12px rgba(14,127,79,0.25)',
          }}
        >
          <Star className="h-5 w-5 text-white" strokeWidth={2} />
          <span className="text-white font-semibold text-sm">
            Bewertung schreiben
          </span>
        </button>
      </div>
    </div>
  );
};

export default ReviewsContent;
